import { log } from './log';

export default class Base64 {
    static encode(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    }

    static decode(str) {
        try {
            return decodeURIComponent(escape(window.atob(str)));
        } catch (error) {
            log.error(error, 'shared/utils/base64 -> base64 decode failed');
            return ''; // FIXME Is this correct? Or should we fail here instead of the callee?
        }
    }
}
